/* eslint-disable compat/compat */
class BisForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.handleScrollTrigger = this.handleScrollTrigger.bind(this)

    if (this?.externalEls?.trigger?.exists) {
      this.listeners.add(
        this.externalEls.trigger.element,
        'click',
        this.handleScrollTrigger,
      )
    }

    this.listeners.add(this.els.form.element, 'submit', (e) => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    const emailAddress = this.els.email.element.value

    this.backInStockSubscribe(variantId, emailAddress)

    if (!this?.els?.newsletter?.exists) return

    if (this.els.newsletter.element.checked === true) {
      this.newsletterSubscribe(emailAddress)
    }
  }

  async backInStockSubscribe (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.showBackInStockSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  async newsletterSubscribe (emailAddress) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: window.theme.klaviyo.newsletterListID,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.showNewsletterSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  showBackInStockSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }

  showNewsletterSuccess () {
    this.els['newsletter-success-label'].element.setAttribute(
      'aria-hidden',
      false,
    )
  }

  handleScrollTrigger () {
    this.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

if (!customElements.get('bis-form')) {
  customElements.define('bis-form', BisForm)
}
